export const formatNumber = (value: number) => {

  if (value >= 1000 && value <= 99999) {
    return `${(value / 1000).toFixed(1)}k+`
  }
 return value
}